<template>
  <v-sheet v-if="loading" width="150" height="80" class="pa-3">
    <v-progress-circular
      indeterminate
      color="primary"
    />
  </v-sheet>
  <v-sheet v-else width="150" height="80" class="px-4">
    <v-row>
      <v-btn @click="playPause" icon>
        <v-icon v-if="!isPlaying" large>mdi-play</v-icon>
        <v-icon v-else large>mdi-pause</v-icon>
      </v-btn>

      <v-btn :disabled="hideNextBtn" icon @click="nextAudio">
        <v-icon>mdi-skip-next</v-icon>
      </v-btn>
      <v-btn :disabled="hidePrevBtn" icon @click="prevAudio">
        <v-icon>mdi-skip-previous</v-icon>
      </v-btn>
    </v-row>

    <v-row>
      <v-slider
        v-model="currentSeconds"
        :max="audioLength"
        dense
        hide-details
        color="green"
        @start="startSeek"
        @end="endSeek"
      />
    </v-row>
  </v-sheet>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'MiniAudioPlayer',
  props: ['callUid'],
  data() {
    return {
      loading: true,
      currentAudioIndex: 0,
      currentSeconds: 0,
      audioLength: 0,
    }
  },

  computed: {
    ...mapGetters({
      call: 'reports_speech_analysis/call',
      playlist: 'audioPlayer/playlist',
      isPlaying: 'audioPlayer/isPlaying',
      currentAudio: 'audioPlayer/currentAudio',
    }),

    hideNextBtn() {
      if (this.playlist?.length <= 1) return true
      if (this.currentAudioIndex === this.playlist.length - 1) return true
      return false
    },

    hidePrevBtn() {
      if (this.playlist?.length <= 1) return true
      if (this.currentAudioIndex === 0) return true
      return false
    },
  },

  watch: {
    isPlaying(newVal) {
      if (newVal) this.currentAudio.play()
      else this.currentAudio.pause()
    },
  },

  methods: {
    ...mapActions({
      loadCall: 'reports_speech_analysis/loadCall',
      initPlaylist: 'audioPlayer/initPlaylist',
      changeCurrentAudio: 'audioPlayer/changeCurrentAudio',
      changeIsPlaying: 'audioPlayer/changeIsPlaying',
    }),
    
    async initAudios() {
      this.loading = true
      await this.loadCall({uid: this.callUid, query: {with: 'audios'}})
      await this.initPlaylist(this.call.audios)
      this.changeCurrentAudio(new Audio(this.playlist[this.currentAudioIndex]))
      this.currentAudio.addEventListener('timeupdate', this.handletimeupdate)
      this.currentAudio.addEventListener('loadeddata', this.handleLoadedData)
      this.currentAudio.addEventListener('ended', this.handleended)
      this.$forceUpdate()
      this.loading = false
    },

    playPause() {
      this.changeIsPlaying()
    },

    handletimeupdate() {
      this.currentSeconds = this.currentAudio.currentTime
    },
    handleLoadedData() {
      this.audioLength = this.currentAudio.duration
    },
    handleended() {
      this.changeIsPlaying(false)
    },

    startSeek() {
      this.currentAudio.removeEventListener('timeupdate', this.handletimeupdate)
    },
    endSeek(seconds) {
      this.currentAudio.currentTime = parseInt(seconds);
      this.currentAudio.addEventListener('timeupdate', this.handletimeupdate)
    },

    nextAudio() {
      this.currentAudio.removeEventListener('timeupdate', this.handletimeupdate)
      this.currentAudioIndex++
      this.currentAudio.pause()
      this.changeIsPlaying(false)
      this.changeCurrentAudio(new Audio(this.playlist[this.currentAudioIndex]))
      this.currentAudio.addEventListener('timeupdate', this.handletimeupdate)
    },
    prevAudio() {
      this.currentAudio.removeEventListener('timeupdate', this.handletimeupdate)
      this.currentAudioIndex--
      this.currentAudio.pause()
      this.changeIsPlaying(false)
      this.changeCurrentAudio(new Audio(this.playlist[this.currentAudioIndex]))
      this.currentAudio.addEventListener('timeupdate', this.handletimeupdate)
    },
  },

  async mounted() {
    await this.initAudios()
  },

  beforeDestroy() {
    this.currentAudio.pause()
    this.changeIsPlaying(false)
    this.currentAudio.removeEventListener('timeupdate', this.handletimeupdate)
    this.currentAudio.removeEventListener('loadeddata', this.handleLoadedData)
    this.currentAudio.removeEventListener('ended', this.handleended)
  },
}
</script>


<style scoped lang="scss">

</style>